var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.config.show.intro && _vm.translations.landing)?_c('b-container',{staticClass:"pt-1"},[_c('b-jumbotron',{staticClass:"jumbotron mt-4",attrs:{"header-html":_vm.translations.landing.title,"lead-html":_vm.translations.landing.leader}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }